// portsActions.ts
export const FETCH_PORTS_SUCCESS = 'FETCH_PORTS_SUCCESS';
export const FETCH_PORTS_ERROR = 'FETCH_PORTS_ERROR';